import { render, staticRenderFns } from "./iconByTooltip.vue?vue&type=template&id=b5485828&scoped=true"
import script from "./iconByTooltip.vue?vue&type=script&lang=js"
export * from "./iconByTooltip.vue?vue&type=script&lang=js"
import style0 from "./iconByTooltip.vue?vue&type=style&index=0&id=b5485828&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5485828",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5485828')) {
      api.createRecord('b5485828', component.options)
    } else {
      api.reload('b5485828', component.options)
    }
    module.hot.accept("./iconByTooltip.vue?vue&type=template&id=b5485828&scoped=true", function () {
      api.rerender('b5485828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/compose/iconByTooltip.vue"
export default component.exports